import React from 'react';
import styled from 'styled-components';
import { Wrapper } from '../shared/commonStyles';
import Title from '../title/Title';
import ShopCard from '../card/ShopCard';

const ShopListWrapper = styled.section`

`;

const SectionShopList = (props) => {
    const shops= [
        {
            name: "DRESSY ROOM YOKOHAMA（横浜）",
            label_dress: true,
            label_original_item: true,
            label_cafe: false,
            time: "11:00〜最終受付17:00",
            notice_time: true,
            tel: "0467-81-4587",
            address1: "神奈川県横浜市西区南幸一丁目１-1",
            address2: "NEWoMan横浜21F　横浜駅直結",
            url: "https://pla-cole.wedding/yokohama-counter",
            map_url: "https://goo.gl/maps/vZ6CKpxpFNkwGYN9A",
        },
        {
            name: "DRESSY CAFE（名古屋）",
            label_dress: true,
            label_original_item: true,
            label_cafe: true,
            time: "9:00〜21:00",
            notice_time: true,
            notice_dress: true,
            notification: "※ドレス試着の最終受付はお問い合わせください",
            tel: "0467-81-4587",
            address1: "愛知県名古屋市中村区名駅一丁目１番１号",
            address2: "ＫＩＴＴＥ名古屋３F　名古屋駅直結",
            url: "https://dressycafe-nagoya.pla-cole.wedding/",
            map_url: "https://goo.gl/maps/WfdzKj6TZWUMxnun6",
        },
        {
            name: "DRESSY CAFE KAMAKURA（鎌倉）",
            label_dress: true,
            label_original_item: true,
            label_cafe: true,
            time: "10:30～16:30",
            notice_time: true,
            tel: "0467-81-4587",
            address1: "神奈川県鎌倉市由比ガ浜２丁目３−2 りんどう鎌倉2F",
            access: "鎌倉駅より徒歩6分",
            url: "https://dressyroom-tea.pla-cole.wedding/",
            map_url: "https://goo.gl/maps/hcHVhsWpY9g5218y7",
        },
        {
            name: "DRESSY ONLINE（ECサイト）",
            label_dress: true,
            label_original_item: true,
            label_cafe: false,
            url: "https://weddingdress.pla-cole.wedding/",
        },
    ]

    return (
      <Wrapper id="shop-list">
        <ShopListWrapper>
            <Title 
                title={"SHOP CAFE"}
                subTitle={"ショップリスト"}    
            />
            {
                shops.map((shop, index) => (
                    <ShopCard 
                        key={index}
                        name={shop.name}
                        label_dress={shop.label_dress}
                        label_original_item={shop.label_original_item}
                        label_cafe={shop.label_cafe}
                        time={shop.time}
                        notice_time={shop.notice_time}
                        notice_dress={shop.notice_dress}
                        tel={shop.tel}
                        address1={shop.address1}
                        address2={shop.address2}
                        access={shop.access}
                        url={shop.url}
                        map_url={shop.map_url}
                        is_pc={props.pc}
                    />
                ))
            }
        </ShopListWrapper>
      </Wrapper>
    );
  };
  
export default SectionShopList;
  